import { createRouter, createWebHistory } from 'vue-router'
import HomeIndex from '@/views/home/HomeIndex.vue'
import HomeCenter from '@/views/home/HomeCenter.vue'
import HomeHome from '@/views/home/HomeHome.vue'
import Cookies from 'js-cookie'

const routes = [
  {
    path: '/',
    name: 'home',
    children: [
      {
        path: '/',
        name: 'homeindex',
        component: HomeIndex,
        meta: {
          title: '青蛙计划'
        },
        children: [
          {
            path: '/',
            name: 'homecenter',
            component: HomeCenter,
            meta: {
              title: '青蛙计划'
            },
            children: [
              {
                path: '/',
                name: 'homehome',
                component: HomeHome,
                meta: {
                  title: '青蛙计划'
                }
              },
              {
                path: '/article',
                name: 'article',
                component: () => import('@/views/article/ArticlePersonal.vue'),
                meta: {
                  requireAuth: true,
                  title: '文章'
                }
              },
              {
                path: '/article/update',
                name: 'articleupdate',
                component: () => import('@/views/article/ArticleUpdate.vue'),
                meta: {
                  requireAuth: true,
                  title: '文章修改'
                }
              },
              {
                path: '/write',
                name: 'write',
                component: () => import('@/views/home/HomeWrite.vue'),
                meta: {
                  requireAuth: true,
                  title: '写作'
                }
              },
              {
                path: '/post/:id',
                name: 'post',
                component: () => import('@/views/article/ArticleDesc.vue')
              },
              {
                path: '/plan',
                name: 'plan',
                component: () => import('@/views/plan/PlanPage.vue'),
                meta: {
                  requireAuth: true,
                  name: '计划'
                }
              }
            ]
          },
          {
            path: '/login',
            name: 'userlogin',
            component: () => import('@/views/home/login/UserLogin.vue'),
            meta: {
              title: '用户登录'
            }
          }
        ]
      },
      {
        path: '/pin',
        name: 'pinindex',
        component: () => import('@/views/pdd/PinIndex.vue'),
        meta: {
          title: 'pdd裁剪计算'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from) => {
  document.title = to.meta.title || '吃掉那只青蛙'

  // 添加路由守卫
  const isLogin = Cookies.get('userid')
  if (to.meta.requireAuth && !isLogin) {
    return { name: 'userlogin' }
  }
  return true // 允许访问
})

export default router
